import "./payments.scss";
import OrderCollapse from "../../components/order-collapse/order-collapse";
import MyAccountWrapper from "../../layout/my-account-wrapper/my-account-wrapper";

const pageDescription =
  <div className={"mb-4"}>
    Oi <strong>Fábio Onofre</strong>.
    <br/><br/>
    Os pedidos abaixo estão aguardando pagamento, para os pedidos via Picpay será necessário iniciar seu pagamento, já para os pedidos via transferência é necessário fazer o envio do comprovante e para os pedidos aguardando renovação é necessário que você escolha uma opção para iniciar o pagamento do pedido.
  </div>

function Payments() {
  return (
      <MyAccountWrapper
        pageName={'Pagamentos'}
        pageDescription={pageDescription}
      >
        <OrderCollapse orderData={1} isPayment={true} />
      </MyAccountWrapper>
  );
}


export default Payments;
